/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_When_RestInputs */

const en_us2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Even at rest`)
};

const pt_br2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesmo em repouso`)
};

const es_419_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluso en reposo`)
};

const pt_pt2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesmo em repouso`)
};

const fr_fr2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Même au repos`)
};

const de_de2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sogar in Ruhe`)
};

const it_it2_bodymap_when_rest = /** @type {(inputs: Bodymap_When_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anche a riposo`)
};

/**
* | output |
* | --- |
* | "Even at rest" |
*
* @param {Bodymap_When_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_when_rest = /** @type {((inputs?: Bodymap_When_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_When_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_when_rest(inputs)
	if (locale === "es-419") return es_419_bodymap_when_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_when_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_when_rest(inputs)
	if (locale === "de-DE") return de_de2_bodymap_when_rest(inputs)
	if (locale === "it-IT") return it_it2_bodymap_when_rest(inputs)
	return en_us2_bodymap_when_rest(inputs)
});
export { bodymap_when_rest as "bodymap.when.rest" }